/* @flow */

import React from "react";
import { useData } from "crustate/react";
import { useTranslate } from "@awardit/react-use-translate";
import { MobileOnlyCarousel } from "@crossroads/shop-views/";
import cn from "classnames";
import { HomeData } from "data";

import styles from "./styles.scss";

type Props = {
  useWrapper?: boolean,
};

type Block = {
  name: string,
  image?: { x1?: string, x2?: string },
  url: string,
  description?: string,
};

const getCategoriesData = (homeData: { [string]: any }): Array<Block> => {
  if (homeData == null) {
    return [];
  }

  return (Object.values(homeData): Array<any>)
    .filter(e => e && Object.prototype.hasOwnProperty.call(e, "carousel"))
    .map((c: { carousel: Block }) => ({
      name: c.carousel.name,
      url: c.carousel.url,
      image: c.carousel.image,
    }));
};

const CategorySection = ({ useWrapper = false }: Props): React$Node => {
  const home = useData(HomeData);
  const t = useTranslate();

  if (home.state !== "LOADED") {
    return null;
  }

  const items = getCategoriesData(home.data);

  if (items.length === 0) {
    return null;
  }

  if (useWrapper) {
    return (
      <div className={styles.wrapper}>
        <h2 className={cn("h3", styles.sectionTitle)}>{t("HOMEVIEW.POPULAR_CATEGORIES")}</h2>
        <MobileOnlyCarousel
          items={items}
          getItemKey={item => item.url}
          desktopSlidesToShow={5}
        />
      </div>
    );
  }

  return (
    <MobileOnlyCarousel
      items={items}
      getItemKey={item => item.url}
      desktopSlidesToShow={5}
      isAutoplay={false}
    />
  );
};

export default CategorySection;
